import { render, staticRenderFns } from "./AddHSCode.vue?vue&type=template&id=bda36bdc"
import script from "./AddHSCode.vue?vue&type=script&lang=js"
export * from "./AddHSCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports